import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { SelectionOption, SelectionOptions } from '@app/shared/interfaces/selection-option';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-autocomplete-backend-input',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatChipsModule,
    MatOptionModule,
    MatAutocompleteModule,
  ],
  templateUrl: './autocomplete-backend-input.component.html',
  styleUrl: './autocomplete-backend-input.component.scss',
})
export class AutocompleteBackendInputComponent implements OnInit, OnDestroy {
  @Input() options!: SelectionOptions;
  @Input() control!: FormControl;
  @Input() label: string | undefined;
  @Input() isDisabled: boolean = false;

  @Input() noSelection: boolean = false;

  @Output() selectionChanged = new EventEmitter<SelectionOption>();
  @Output() searchStringChange = new EventEmitter<string>();

  private destroy$ = new Subject<void>();

  private onInputChange$ = new Subject<string>();

  previousString: string = '';

  ngOnInit() {
    if (!this.options) {
      this.options = [];
    }

    this.control.valueChanges.subscribe((value) => {
      this.onInputChange(value);
    });

    this.onInputChange$.pipe(debounceTime(300), takeUntil(this.destroy$)).subscribe((debouncedValue) => {
      this.searchStringChange.emit(debouncedValue);

      if (debouncedValue === '') {
        this.control.setValue(null);
        this.control.markAsDirty();
      }
    });
  }

  onInputChange(newValue: any): void {
    if (typeof newValue === 'string') {
      this.previousString = newValue;
      this.onInputChange$.next(newValue);
    }
  }

  onFirstClick(): void {
    if (!this.options || this.options.length === 0) {
      this.searchStringChange.emit('');
    }
  }

  onSelection(event: any): void {
    this.selectionChanged.emit(event.option.value);
  }

  displayFn(option: SelectionOption): string {
    return option?.value || '';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
